module.exports = __webpack_public_path__ + "img/rs-logo.5daf6cd3.svg";